// Teacher shell — SaaS-clean, classroom-focused. Live in R9.

import type { ReactNode } from 'react';

import { SidebarShell, type NavEntry } from '../SidebarShell';

const NAV: NavEntry[] = [
  { to: '/$locale', labelKey: 'app.nav.overview', icon: '🏠' },
  { to: '/$locale/teacher/classes', labelKey: 'app.nav.classes', icon: '📚' },
  { to: '/$locale/teacher/assignments', labelKey: 'app.nav.assignments', icon: '📝' },
  { to: '/$locale/teacher/tasks', labelKey: 'app.nav.tasks', icon: '✅' },
  { to: '/$locale/teacher/messages', labelKey: 'app.nav.messages', icon: '💬' },
];

export function TeacherShell({ children }: { children: ReactNode }) {
  return (
    <SidebarShell titleKey="app.common.role_teacher" nav={NAV}>
      {children}
    </SidebarShell>
  );
}
